import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CreateTaskTypeDTO, TaskType } from "../types/TaskType";
import {
  createTaskType,
  getTaskTypes,
  getAllTaskTypes,
  updateTaskType,
  deleteTaskType,
} from "./task-types.service";
import {
  getAllTaskTypesQueryKey,
  getTaskTypesQueryKey,
  invalidateTaskTypesQueries,
} from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export function useAllTaskTypes() {
  return useQuery({
    queryKey: getAllTaskTypesQueryKey(),
    queryFn: getAllTaskTypes,
    staleTime: Infinity,
    gcTime: INTERVAL.DAY,
  });
}

export const useTaskTypes = (ids: number[]) => {
  return useQuery({
    queryKey: getTaskTypesQueryKey(ids),
    queryFn: () => getTaskTypes(ids),
    staleTime: Infinity,
  });
};

export const useCreateTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskType: CreateTaskTypeDTO) => createTaskType(taskType),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};

export const useUpdateTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (taskType: TaskType) => updateTaskType(taskType),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};

export const useDeleteTaskType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteTaskType(id),
    onSuccess: () => {
      return invalidateTaskTypesQueries(queryClient);
    },
  });
};
